// PPh Final 4(2) Example Cases
// Sources:
// - PP 55/2022 (UMKM 0.5% final tax, individual exemption up to Rp500 juta)
// - PP 34/2017 jo. PP 34/2016 (Sewa Tanah/Bangunan 10%)
// - PP 9/2022 (Jasa Konstruksi rates)
// - PP 34/2016 (Pengalihan Hak atas Tanah/Bangunan 2.5%)

export const PPH_FINAL_42_EXAMPLES = [
  {
    titleKey: "taxCalculator.pphFinal42.examples.case1.title",
    objectTypeKey: "taxCalculator.pphFinal42.examples.case1.objectType",
    descriptionKey: "taxCalculator.pphFinal42.examples.case1.description",
    autoFillData: {
      objectType: "UMKM",
      grossAmount: 80000000,
      isIndividual: true,
      omzetRange: "0_500",
    },
  },
  {
    titleKey: "taxCalculator.pphFinal42.examples.case2.title",
    objectTypeKey: "taxCalculator.pphFinal42.examples.case2.objectType",
    descriptionKey: "taxCalculator.pphFinal42.examples.case2.description",
    autoFillData: {
      objectType: "SEWA_TANAH_BANGUNAN",
      grossAmount: 120000000,
    },
  },
  {
    titleKey: "taxCalculator.pphFinal42.examples.case3.title",
    objectTypeKey: "taxCalculator.pphFinal42.examples.case3.objectType",
    descriptionKey: "taxCalculator.pphFinal42.examples.case3.description",
    autoFillData: {
      objectType: "JASA_KONSTRUKSI",
      grossAmount: 500000000,
      constructionType: "PELAKSANA",
      qualification: "KECIL",
    },
  },
  {
    titleKey: "taxCalculator.pphFinal42.examples.case4.title",
    objectTypeKey: "taxCalculator.pphFinal42.examples.case4.objectType",
    descriptionKey: "taxCalculator.pphFinal42.examples.case4.description",
    autoFillData: {
      objectType: "PENGALIHAN_TANAH_BANGUNAN",
      grossAmount: 800000000,
      propertyType: "UMUM",
    },
  },
];
